export default {
  userId: 'ID Użytkownika',
  privacyPolicy: 'Polityka prywatności',
  pl: 'Polska',
  settings: 'Ustawienia',
  advancedSettings: 'Zaawansowane ustawienia',
  agreementTitle: 'Zgoda na pliki cookie i dane',
  settingsInfo: 'Na stronie internetowej można znaleźć informacje dotyczące celów przetwarzania i dostawców, którzy przetwarzają dane osobowe na naszej stronie internetowej',
  dataAdministratorIs: 'Administratorem danych (art. 4.7 RODO) jest firma',
  updatedAt: 'Zapisanie ustawień',
  acceptAll: 'Akceptuj wszystkie',
  customizeSelection: 'Dostosuj wybór',
  saveAndClose: 'Zapisz i zamknij',
  findOut: 'Dowiedz się więcej',
  all: 'Wszyscy',
  necessary: 'Niezbędne',
  survey: 'Pomiar',
  marketing: 'Marketing',
  social: 'Media społecznościowe',
  advertisement: 'Reklamy',
  cookies: 'Ciasteczka',
  admin: 'Administrator danych',
  purpose: 'Cel',
  vendors: 'Dostawcy',
  name: 'Nazwa',
  value: 'Wartość',
  vendor: 'Dostawca',
  unknown: 'Nieznany',
  statistics: 'Statystyka',
  functional: 'Funkcjonowanie strony',
  validity: 'Ważność',
  session: 'sesja',
  minute: '1 minuta',
  hour: '1 godzina',
  day: '1 dzień',
  '90days': '90 dni',
  week: '1 tydzień',
  month: '1 miesiąc',
  '3months': '3 miesiące',
  '6months': '6 miesięcy',
  year: '1 rok',
  '13months': '13 miesięcy',
  '2years': '2 lata',
  persistent: 'trwały'
}
